import { encryptPayload, decryptPayload } from './crypto';
import { encryptVaultPayload, decryptVaultPayload, getVaultStatus } from './vault';

// The independently deployable containment release can still read/write its
// old encryption format. Enrollment never silently falls back to that key.
export async function encryptClinicalPayload(value, { requireVault = false } = {}) {
  const status = await getVaultStatus();
  if (status.enrolled) return encryptVaultPayload(value);
  if (requireVault) throw new Error('Set up device charting before saving with automatic offline sync.');
  return encryptPayload(value);
}

export async function decryptClinicalPayload(value) {
  return value?.version === 2 ? decryptVaultPayload(value) : decryptPayload(value);
}
